<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm @submit="signup">
                <h1>Register</h1>
                <p class="text-muted">Create your account</p>
                <!--<CInput
                  name="username"
                  v-model="username"
                  placeholder="Username"
                  autocomplete="username"
                >-->
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                  name="email"
                  v-model="email"
                  placeholder="Email"
                  autocomplete="email"
                  prepend="@"
                  required
                />
                <CInput
                  name="password"
                  v-model="password"
                  placeholder="Password"
                  type="password"
                  autocomplete="new-password"
                  required
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CInput
                  name="repassword"
                  v-model="repassword"
                  placeholder="Repeat password"
                  type="password"
                  autocomplete="new-password"
                  class="mb-4"
                  required
                  ref="repassword"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CButton type="submit" color="success" block>Create Account</CButton>
              </CForm>
            </CCardBody>
            <CCardFooter class="p-4">
              <CRow>
                <CCol col="6">
                  <CButton block color="facebook">
                    Facebook
                  </CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="twitter">
                    Twitter
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  name: 'Register',
  data: function(){
    return {
      username: '',
      email: '',
      password: '',
      repassword: ''
    }
  },
  methods: {
    signup(e) {
        var self = this;
        if(self.password !== self.repassword){
          let input = self.$refs.repassword.$el.querySelector('input');
          input.setCustomValidity('Passwords Don\'t Match');
          input.reportValidity();
          e.preventDefault();
        }
        firebase.auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(data => {
          /*data.user
            .updateProfile({
              displayName: this.form.name
            })
            .then(() => {});*/
            console.log(data);
            data.user.sendEmailVerification().then(function() {
              self.$router.push("/pages/login");
            }).catch(function(error) {
              // An error happened.
            });
          
        })
        .catch(err => {
          this.error = err.message;
        });
        e.preventDefault();
    }
  }
}
</script>
